import React, {useContext} from 'react';
import { Route, Redirect } from 'react-router-dom';
import {UserContext} from "../../hooks/UserContext";

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    const { user, isLoading } = useContext(UserContext);

    if(isLoading) {
        // An element, never a bare text node: a page translator replaces text nodes in place, and
        // React then throws NotFoundError removing one it no longer owns, taking down the whole app.
        return <div>Loading</div>
    }

    const render = props => {
        if (user && user.isLogged && restricted) {
            return <Redirect to={"/"} />;
        }

        return <Component {...props} />;
    };

    return <Route {...rest} render={render} />
};

export default PublicRoute;